import { z } from 'zod';
import { PLANS } from '../plan.js';
import { isoTimestampSchema, uuidSchema } from './base.js';

// 档位真相源是 plan.ts 的 PLANS——手写枚举曾漏掉 pro_ai（「同类字段漏项」模式），
// 派生保证任何新增档位自动进 schema。
export const userPlanSchema = z.enum(PLANS);

export const userSettingsSchema = z
  .object({
    weekStartsOn: z.union([z.literal(0), z.literal(1)]).default(1),
    useDeviceTimezoneForToday: z.boolean().default(true),
    language: z.string().default('zh-CN'),
    themePreference: z.enum(['system', 'light', 'dark']).default('system'),
  })
  .partial();

export const userProfileSchema = z.object({
  user_id: uuidSchema,
  display_name: z.string().nullable(),
  avatar_url: z.string().nullable(),
  timezone: z.string().default('Asia/Shanghai'),
  plan: userPlanSchema.default('free'),
  settings: userSettingsSchema.default({}),
  created_at: isoTimestampSchema,
  updated_at: isoTimestampSchema,
  row_version: z.union([z.number().int(), z.string()]),
});

export type UserProfile = z.infer<typeof userProfileSchema>;
export type UserSettings = z.infer<typeof userSettingsSchema>;
